module.exports = __webpack_public_path__ + "img/vip-1000.04662c69.png";